import React from 'react';
import './FlowVellaLoader.css';

/**
 * Animated FlowVella F Logo Loader
 * Three blocks animate in sequence: left vertical, top right, middle right
 * Uses exact dimensions from the official FlowVella F logo
 */
export const FlowVellaLoader: React.FC<{ message?: string }> = ({ message = "Loading Web Creator" }) => {
  return (
    <div className="flowvella-loader">
      <svg
        className="flowvella-logo-svg"
        width="124"
        height="124"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Left vertical bar - animates first */}
        <rect
          className="f-block f-left"
          x="8"
          y="5"
          width="16"
          height="53"
          fill="#0071BC"
        />

        {/* Top horizontal bar - animates second */}
        <rect
          className="f-block f-top"
          x="28"
          y="5"
          width="27"
          height="16"
          fill="#0071BC"
        />

        {/* Middle horizontal bar - animates third */}
        <rect
          className="f-block f-middle"
          x="28"
          y="24"
          width="27"
          height="16"
          fill="#0071BC"
        />
      </svg>
      <p className="loading-text">{message}</p>
    </div>
  );
};
